<template>
    <div style="overflow:auto;">
        <template v-if="isLoaded">
            <div>
                <div style="display: flex; height: 70px; align-items: center; border-bottom: 1px solid rgb(245, 245, 245);">
                    <div style="margin-left: 20px; font-size: 24px; font-weight: 700;">포지션 찾기</div>
                    <div style="flex: 1 1 0%;"></div><div style="display: flex;"></div>
                </div>
            </div>

            <MyPositionResult :show-position="true" :init-position="position" :name="name"></MyPositionResult>
        </template>

        <!--<div style="height:50px; display:flex; background-color: #fe6100">-->
            <!--<div style="display:grid; place-items: center; width:40px;" ></div>-->
            <!--<div style="display:grid; place-items: center; flex:1;">-->
                <!--<img :src="require('@/assets/title.png')" style="height:25px;">-->
            <!--</div>-->
            <!--<div style="width:40px;"></div>-->
        <!--</div>-->
        <!--<div style="overflow:auto; flex:1; border-top-right-radius: 15px; border-top-left-radius: 15px;">-->
            <!--<MyPositionResult :name="name" :position="position"></MyPositionResult>-->
            <!--<div style="text-align:center; background-color: #fff4d2; padding-bottom:20px;" @click="goToLanding">-->
                <!--<div style="height:36px; line-height:36px; padding:0px 20px; text-align:center; display:inline-block; color:white; font-weight:bold; border-radius:18px; background-color: #fe6100;">나의 포지션은?</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import MyPositionResult from "../common/MyPositionResult";


    export default {
        name: "SharePosition",
        components: {MyPositionResult},
        data(){
            return {
                position : '',
                name : '',
                isLoaded : false,
            }
        },
        methods : {
            goToLanding(){
                this.$GlobalRouter.push('/share/position/landing');
            },
            async getPosition(target){
                const parameters = {target : target};
                const res = await this.$Axios.get('/api/share/position', {params : parameters});
                if(res.data.code === 0){
                    this.position = res.data.position;
                    this.name = res.data.name;
                    this.isLoaded = true;
                }else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.getPosition(this.$route.query.target)
        }
    }
</script>

<style scoped>

</style>